import { LegalClientSourcesOfIncomeEntity } from 'api/types/entity';
import { TFunc } from 'libs/i18n';

import { SourcesOfIncomeFormType } from '../../forms/sourcesOfIncomeForm';

export const parseSourcesOfIncomeValue = (
  sourcesOfIncome: LegalClientSourcesOfIncomeEntity | undefined,
  t: TFunc
) => {
  const values: SourcesOfIncomeFormType['sourcesOfIncome'] = {
    ...sourcesOfIncome,
    incomeSources:
      sourcesOfIncome?.incomeSources?.map((v) => ({
        value: v,
        label: t(`client.legal.sourcesOfIncome.incomeSources.types.${v}`),
      })) ?? [],
    financialSources:
      sourcesOfIncome?.financialSources?.map((v) => ({
        value: v,
        label: t(`client.legal.sourcesOfIncome.financialSources.types.${v}`),
      })) ?? [],

    files: sourcesOfIncome?.files ?? [],
  };

  return values;
};
